//@flow
import type { FluxStandardAction } from '../../types'
import { createSelector } from 'reselect'

import { getRoot } from '../rootSelector'

//Constants
export const INTO_ARTICLES_STORE = 'opinary/INTO_ARTICLES_STORE'

//Actions

export function intoArticleStore(payload: string[]): FluxStandardAction {
  return {
    type: INTO_ARTICLES_STORE,
    payload,
  }
}

//Selectors
export const getArticles = createSelector(
  getRoot,
  ({ automationStore }) => automationStore.articleStore
)

//Reducer
const defaultState = null

export default function reducer(
  state: ?(string[]) = defaultState,
  action: FluxStandardAction
) {
  switch (action.type) {
    case INTO_ARTICLES_STORE:
      return action.payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/automation/articleStore.js